import { ConversationTag } from '../typings';

export const sortTagsBasedOnSelection = (
  a: ConversationTag,
  b: ConversationTag,
  selectedTags: string[]
) => {
  const isASelected = selectedTags.includes(a.name);
  const isBSelected = selectedTags.includes(b.name);

  if (!isASelected && isBSelected) return 1;

  if(isASelected && !isBSelected) return -1;

  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }

  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }

  return 0;
};
